const LogOutIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12 14.625L14.625 12M14.625 12L12 9.375M14.625 12H5M5 7.84202V7.80017C5 6.82008 5 6.32967 5.19074 5.95532C5.35852 5.62604 5.62604 5.35852 5.95532 5.19074C6.32967 5 6.82008 5 7.80017 5H16.2002C17.1803 5 17.6696 5 18.044 5.19074C18.3733 5.35852 18.6417 5.62604 18.8094 5.95532C19 6.3293 19 6.81912 19 7.7973V16.2031C19 17.1813 19 17.6704 18.8094 18.0444C18.6417 18.3737 18.3733 18.6417 18.044 18.8094C17.67 19 17.1809 19 16.2027 19H7.7973C6.81912 19 6.3293 19 5.95532 18.8094C5.62604 18.6417 5.35852 18.3734 5.19074 18.0441C5 17.6698 5 17.1801 5 16.2V16.1562"
      stroke="#26262B"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default LogOutIcon;
